module.exports = __webpack_public_path__ + "media/1.7935ca27.mp3";